import { Component, OnInit, Input, forwardRef } from "@angular/core";
import {
  FormControl,
  NG_VALUE_ACCESSOR,
  ControlContainer,
  AbstractControl,
} from "@angular/forms";
import { FormBaseElement } from "../form-base-element";

@Component({
  selector: "app-foldable-text-input",
  templateUrl: "./foldable-text-input.component.html",
  styleUrls: ["./foldable-text-input.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FoldableTextInputComponent),
      multi: true,
    },
  ],
})
export class FoldableTextInputComponent extends FormBaseElement {
  @Input() title: string;
  @Input() inputValue: string = "";
  @Input() control: FormControl;
  @Input() isDisable: boolean = false;

  public isOpen: boolean = false;

  constructor() {
    super();
  }

  open() {
    this.isOpen = true;
  }

  save() {
    if (!this.isComponentDisabled) {
      this.control.setValue(this.inputValue);
      this.isOpen = false;
    }
  }

  close() {
    if (!this.isComponentDisabled) {
      this.inputValue = "";
      this.control.reset();
    }
    this.isOpen = false;
  }

  onKeyUp(val) {
    if (!this.isComponentDisabled) {
      this.inputValue = val.target.value;
    }
  }

  get isComponentDisabled() {
    return this.isDisable;
  }

  get actionMsg() {
    if (this.inputValue && !this.isOpen) {
      return "რედაქტირება";
    } else if (this.isOpen) {
      return "გაუქმება";
    } else {
      return "შევსება";
    }
  }
}
